import { useState, useCallback } from 'react'
import { useSubscription } from 'streamr-client-react'
import useIsMounted from '~hooks/useIsMounted'

const DATA_HISTORY_STREAM_ID = '0x7c56a3197f4277dcf08881a7988f3150d1f87510/DATA-historical-price'

export default function useHistoricalDataTokenStream() {
    const isMounted = useIsMounted()

    const [ranges, setRanges] = useState({
        today: [],
        week: [],
        month: [],
        year: [],
        all: [],
    })

    const onHistoryMessage = useCallback(({
        todayPoints: today,
        weekPoints: week,
        monthPoints: month,
        yearPoints: year,
        allPoints: all,
    }) => {
        if (isMounted()) {
            setRanges({
                today,
                week,
                month,
                year,
                all,
            })
        }
    }, [isMounted])

    useSubscription({
        stream: DATA_HISTORY_STREAM_ID,
        resend: {
            last: 1,
        },
    }, {
        onMessage: onHistoryMessage,
    })

    return ranges
}
